export const sortByInstance = (a, b) => {
  if (a.instance_type < b.instance_type) return -1
  if (a.instance_type > b.instance_type) return 1
  
  return 0;
}